import React, {useContext} from "react";
import SectionCard from "../common/SectionCard";
import DetailGrid from "../common/DetailGrid";
import {EditOutlined, TeamOutlined} from "@ant-design/icons";
import {useLocation, useNavigate} from "react-router-dom";
import {Button} from "antd";
import UserLoginContext from "../../../../context/userLoginContext";
import {capitalizeString, firstLetterUpperCase} from "../../../../utility/utility";
import EmptyData from "../../../common/empty-data/empty-data";
import {PersonStanding} from "lucide-react";
import CopyContent from "../../../../common/copy-content";

const FamilyTab = ({employeeData}: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {user} = useContext(UserLoginContext);
    const isActiveEmployee = location.state?.isActive ?? true;
    const navigateToFamilyDetail = () => navigate(`/employee/edit/family`, {state: {empId: employeeData.id}});
    const familyDetails = employeeData?.familyDetails;

    return (
        <SectionCard
            icon={<TeamOutlined style={{backgroundColor: "#fce7f3", color: "#be185d"}}/>}
            title="Family Members"
            extra={
                user?.isAdmin && isActiveEmployee && (
                    <Button type={"link"} onClick={() => navigateToFamilyDetail()}> <EditOutlined/> </Button>
                )
            }
        >
            {familyDetails && familyDetails.length > 0 ? (
                <div className="family-cards">
                    {familyDetails.map((member: any, index: number) => (
                        <SectionCard
                            key={index}
                            title={member.name}
                            icon={
                                <div className={"employee-detail-avatar family"}>
                                    {member?.name.slice(0, 2)}
                                </div>
                            }
                            tag={member.relationType}
                        >
                            <DetailGrid
                                data={[
                                    {label: "Gender", value: firstLetterUpperCase(member.gender)},
                                    {
                                        label: "Mobile Number",
                                        value: member?.mobileNumber?.number ? (
                                            <CopyContent
                                                content={`${member?.mobileNumber?.countryCode ?? ""}${member?.mobileNumber?.number}`}
                                            >
                                                <a
                                                    href={`tel:${member?.mobileNumber?.countryCode ?? ""}${member?.mobileNumber?.number}`}
                                                    className="email-link"
                                                >
                                                    {`${member?.mobileNumber?.countryCode ?? ""} ${member?.mobileNumber?.number}`}
                                                </a>
                                            </CopyContent>
                                        ) : (
                                            "-"
                                        )
                                    },
                                ]}
                            />
                        </SectionCard>
                    ))}
                </div>
            ) : (
                <EmptyData
                    icon={<PersonStanding className={'family-empty-data-icon'}/>}
                    title={"No Family Information"}
                    subtitle={"Add family details to manage emergency contacts and benefits"}
                />
            )}
        </SectionCard>
    );
};

export default FamilyTab;
